var bowser      = require("bowser").getParser(window.navigator.userAgent),
    browserName = bowser.getBrowserName().toLocaleLowerCase(),
    get         = require("object-path").get,
    isIosApp    = require("app/utils/isIosApp"),
    osName      = bowser.getOSName().toLocaleLowerCase(),
    supportsAV1 = false;

/**
 * Create media source configuration for Radiant Media Player from the
 * provided watching session.
 *
 * @param    {Object}  session  The watching session
 * @param    {Object}  media    The media item
 * @returns  {Object}  The media source config
 */
module.exports = function(session, media) {
    var streams = get(session, "urls", []),
        hlsStream,
        dashStream,
        setup   = {
            src: {}
        };

    // HLS Stream
    hlsStream = streams.find(function(stream) {
        return stream.type === "hls_adaptive";
    }) || streams.find(function(stream) {
        return stream.type === "adaptive";
    }) || null;

    if (hlsStream) {
        setup.src.hls = hlsStream.path;
    }

    // Dash Stream
    if (osName === "ios" || isIosApp || [
        "album_track",
        "audio",
        "podcast_episode"
    ].includes(media.type)) {
        // No Dash streams at all
    }
    else if (["firefox", "microsoft edge"].includes(browserName)
        || !supportsAV1
    ) {
        dashStream = streams.find(function(stream) {
            return stream.type === "dash_adaptive";
        }) || null;
    }
    else {
        dashStream = streams.find(function(stream) {
            return stream.type === "dash_av1_adaptive";
        }) || streams.find(function(stream) {
            return stream.type === "dash_adaptive";
        }) || null;
    }

    if (dashStream) {
        setup.src.dash = dashStream.path;

        if (dashStream.keys) {
            setup.shakaDrm  = {
                clearKeys: dashStream.keys
            };
        }
    }

    return setup;
};

(function() {
    var video,
        canPlayAV1;

    if ("mediaCapabilities" in navigator) {
        navigator.mediaCapabilities.decodingInfo({
            type:  "file",
            video: {
                contentType: 'video/mp4; codecs="av01.0.04M.08"',
                width:       1920,
                height:      1080,
                bitrate:     100000,
                framerate:   30
            }
        }).then(function(result) {
            if (result.supported && result.smooth) {
                supportsAV1 = true;
            }
        });
    }
    else {
        video      = document.createElement("video");
        canPlayAV1 = video.canPlayType('video/mp4; codecs="av01.0.08M.08"');

        if (canPlayAV1 === "probably") {
            supportsAV1 = true;
        }
    }
})();
